// extracted by mini-css-extract-plugin
export var menuIcon = "_mi-0";
export var menuIconInline = "_mi-1";